import Api from '../../api/index'
import {
  clearLoginFingerprint,
  getBrowserFingerprintData,
  getFingerDevice,
  saveLoginFingerprint
} from '@/utils/fingerprint'
import { disconnectMarketSocket } from '@/utils/marketSocket'

function getStorageUserInfo() {
  try {
    return JSON.parse(localStorage.getItem('userInfo')) || null
  } catch (e) {
    return null
  }
}

const storageUserInfo = getStorageUserInfo()

const user = {
  namespaced: true,
  state: {
    companyName: localStorage.getItem('companyName') || '华晨智能建造有限公司',
    userRole: localStorage.getItem('userRole') || '超级管理员',
    token: localStorage.getItem('token') || '',
    userInfo: storageUserInfo,
    companyList: storageUserInfo?.company?.companyList || []
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
      localStorage.setItem('token', token)
    },
    SET_USER_INFO(state, userInfo) {
      const nextUserInfo = userInfo ? { ...userInfo } : null
      if (nextUserInfo && !nextUserInfo.auth) {
        nextUserInfo.auth = state.userInfo?.auth || getStorageUserInfo()?.auth || null
      }
      if (nextUserInfo && nextUserInfo.menu_tree == null) {
        nextUserInfo.menu_tree = state.userInfo?.menu_tree || getStorageUserInfo()?.menu_tree || []
      }
      state.userInfo = nextUserInfo
      state.companyList = nextUserInfo?.company?.companyList || []
      localStorage.setItem('userInfo', JSON.stringify(nextUserInfo || {}))
    },
    SET_COMPANY_LIST(state, companyList) {
      state.companyList = Array.isArray(companyList) ? companyList : []
    },
    SET_COMPANY(state, company) {
      state.companyName = company.name
      state.userRole = company.role
      localStorage.setItem('companyName', company.name)
      localStorage.setItem('userRole', company.role)
    },
    CLEAR_USER(state) {
      disconnectMarketSocket()
      state.token = ''
      state.userInfo = null
      state.companyList = []
      localStorage.removeItem('token')
      localStorage.removeItem('userInfo')
      localStorage.removeItem('vuex');
      clearLoginFingerprint()
    }
  },
  actions: {
    login({ commit }, payload) {
      return getBrowserFingerprintData().then(async ({ fingerprint }) => {
        const fingerDevice = await getFingerDevice()
        const loginHeaders = {
          fingerprint,
          'Finger-Device': fingerDevice
        }
        const request = payload.type === 'SmsLogin'
          ? Api.smsLogin({
            mobile: payload.mobile,
            vcode: payload.vcode, //测试：4362
            fingerprint,
            fingerDevice
          }, { headers: loginHeaders })
          : Api.accountLogin({
            account: payload.account,
            password: payload.password,
            fingerprint,
            fingerDevice
          }, { headers: loginHeaders })

        return request.then(res => ({ res, fingerprint }))
      }).then(({ res, fingerprint }) => {
        if(res.code === 200) {
          const data = res.data || {}
          saveLoginFingerprint(fingerprint)
          commit('SET_TOKEN', data?.auth?.access_token || '')
          commit('SET_USER_INFO', data)
          return res
        }

        return Promise.reject(res)
      })
    },
    logout({ commit }) {
      return Api.logout().then((res) => {
        if(res.code === 200) return res
        return Promise.reject(res)
      }).finally(() => {
        commit('CLEAR_USER')
      })
    }
  }
}

export default user
